import { State } from '../../../types';

export function getSelectedWarehouseId(a: State): number | undefined {
    // @ts-ignore
    const warehouseId = a.router.location.query?.warehouse;
    return warehouseId ? parseInt(warehouseId, 10) : undefined;
}
